import React from 'react';
import { useTranslation } from "react-i18next";
import "./taxTacDialog.css"

function TaxDeclarationTermsAndCondition() {
  const { t } = useTranslation("common");
  return (
    <>
    <ul className="taxTacSubList"> 
            <li className='d-flex mb-3'>
            <div  className='sn_1  h-50'></div> 
            <div className='taxTacPoints'>
            {t("taxDeclaration.termsAndConditionPoint1")}
            </div>
            </li>

            <li className='d-flex mb-3'>
            <div className='sn_2  h-50'></div> 
            <div className='taxTacPoints'>
            {t("taxDeclaration.termsAndConditionPoint2")}
            </div>
            </li>

            <li className='d-flex mb-3'>
            <div className='sn_3  h-50'></div> 
            <div className='taxTacPoints'>
            {t("taxDeclaration.termsAndConditionPoint3")}
            </div>
            </li>
            <li className='d-flex mb-3'>
            <div className='sn_4  h-50'></div> 
            <div className='taxTacPoints'>
            {t("taxDeclaration.termsAndConditionPoint4")}

            </div>
            </li>
            <li className='d-flex mb-3'>
            <div className='sn_5  h-50'></div> 
            <div className='taxTacPoints'>
            {t("taxDeclaration.termsAndConditionPoint5")}

            </div>
            </li>
            <li className='d-flex mb-3'>
            <div className='sn_6  h-50'></div> 
            <div className='taxTacPoints'>
            {t("taxDeclaration.termsAndConditionPoint6")}
            </div>
            </li>
            <li className='d-flex mb-3'>
            <div className='sn_7  h-50'></div> 
            <div className='taxTacPoints'>
            {t("taxDeclaration.termsAndConditionPoint7")}
            </div>
            </li>
            <li className='d-flex mb-3'>
            <div  className='sn_8  h-50' ></div> 
            <div className='taxTacPoints'>
            {t("taxDeclaration.termsAndConditionPoint8")}
            </div>
            </li>
            <li className='d-flex mb-3'>
            <div className='sn_9  h-50' ></div> 
            <div className='taxTacPoints'>
            {t("taxDeclaration.termsAndConditionPoint9")}
            </div>
            </li>


          </ul>

    </>
  )
}

export default TaxDeclarationTermsAndCondition